function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 100,
  height: 50
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 50,
  width: 100,
  height: 100
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#fff",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#fff",
  stopOpacity: 0.2
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 1
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90%",
  stopColor: "#fff",
  stopOpacity: 0.2
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 44,
  stroke: "url(#gradient-1)",
  strokeWidth: 12,
  fill: "none",
  opacity: 1,
  clipPath: "url(#clip-1)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 44,
  stroke: "url(#gradient-2)",
  strokeWidth: 12,
  fill: "none",
  opacity: 1,
  clipPath: "url(#clip-2)"
});

var SvgGradientCircleWhite = function SvgGradientCircleWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGradientCircleWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gradient-circle-white.cb24f962.svg";
export { ForwardRef as ReactComponent };